var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudArrowUpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/cloud-arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8001 27.2001C4.82365 27.2001 1.6001 23.9765 1.6001 20.0001C1.6001 16.8295 3.64944 14.1376 6.49577 13.1767C6.43283 12.7938 6.4001 12.4008 6.4001 12C6.4001 8.0236 9.62365 4.80005 13.6001 4.80005C16.2247 4.80005 18.5213 6.20439 19.7795 8.30265C20.3503 8.10653 20.9628 8.00005 21.6001 8.00005C24.6929 8.00005 27.2001 10.5073 27.2001 13.6C27.2001 14.1334 27.1255 14.6493 26.9863 15.138C29.0165 16.2109 30.4001 18.3439 30.4001 20.8C30.4001 24.3347 27.5347 27.2001 24.0001 27.2001H8.8001ZM15.2501 22.8C15.2501 23.2143 15.5859 23.55 16.0001 23.55C16.4143 23.55 16.7501 23.2143 16.7501 22.8L16.7501 14.31L20.6505 18.5104C20.9324 18.8139 21.4069 18.8315 21.7104 18.5496C22.014 18.2678 22.0315 17.7932 21.7497 17.4897L16.5497 11.8897C16.4078 11.7369 16.2087 11.65 16.0001 11.65C15.7915 11.65 15.5924 11.7369 15.4505 11.8897L10.2505 17.4897C9.96865 17.7932 9.98623 18.2678 10.2898 18.5496C10.5933 18.8315 11.0678 18.8139 11.3497 18.5104L15.2501 14.3099L15.2501 22.8Z",
    fill: "#5C41FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudArrowUpIcon);
export default __webpack_public_path__ + "static/media/CloudArrowUpIcon.ede5f402e61aa9e83b6c4715b0b37539.svg";
export { ForwardRef as ReactComponent };